'use client';

import FAQQuestions from './faq-questions';
const FAQContent = () => {
  return <div className='homepage-container relative' data-sentry-component="FAQContent" data-sentry-source-file="faq-content.tsx">
            <span className='mb-4 block text-center text-body-16 font-bold text-text-black'>سوالات متداول</span>

            <FAQQuestions data-sentry-element="FAQQuestions" data-sentry-source-file="faq-content.tsx" />
        </div>;
};
export default FAQContent;